import { PAGE_SIZE, usePagedFeed } from "./use-paged-feed";

import type { Database } from "../../../__definitions__/database-definitions";
import type { PagedFeed } from "./use-paged-feed";

/** A Communication, Survey or Digital Asset as the dashboard's feeds and search show it. */
export type FeedItem = Database["public"]["Functions"]["recently_edited"]["Returns"][number];

/** One kind of entity the feed can be narrowed to. */
export type RecentlyEditedType = FeedItem["entity_type"];

/**
 * The Communications, Surveys and Digital Assets most recently edited, newest first, a page at a
 * time. With `userEdited`, only those the user has edited themselves; with `entityType`, only that
 * kind.
 */
export function useRecentlyEdited(
  userEdited: boolean,
  entityType?: RecentlyEditedType,
): PagedFeed<FeedItem> {
  return usePagedFeed<FeedItem>(
    async ({ supabase, account_id }, offset) => {
      const { data, error } = await supabase.rpc("recently_edited", {
        account_id_: account_id,
        size_: PAGE_SIZE,
        offset_: offset,
        user_edited_: userEdited,
        ...(entityType && { entity_type_: entityType }),
      });
      if (error) throw error;
      return data;
    },
    [userEdited, entityType],
  );
}
